{
 "id": "okubo-west-a", "light": 0.6,
 "_note": "2x art scene: Okubo west (Koreatown streets with Golden Gai pockets), painted by client/src/hd-scene.ts with the kinds of client/src/hd-fronts-okubo-west.ts. Cosmetic only: buildings sit on existing solid tiles; no collision, shops or zones change. Tile units. Buildings stack north to south, each painting its own south wall (face rows).",
 "rect": {
  "x": 128,
  "y": 0,
  "w": 72,
  "h": 60
 },
 "buildings": [
  {
   "id": "oa-n1",
   "x": 130,
   "y": 0,
   "w": 18,
   "h": 4,
   "face": 2,
   "kind": "office",
   "roof": "ribbed",
   "props": [
    [
     "ac",
     1,
     0.4
    ],
    [
     "ac",
     3,
     0.4
    ],
    [
     "okuboWestBoard",
     9,
     0.3
    ],
    [
     "vent",
     16,
     1
    ]
   ]
  },
  {
   "id": "oa-n2",
   "x": 148,
   "y": 0,
   "w": 17,
   "h": 4,
   "face": 2,
   "kind": "okuboWestBbq",
   "roof": "tar",
   "sign": {
    "text": "肉",
    "color": "pink"
   },
   "props": [
    [
     "okuboWestFlue",
     2,
     0.6
    ],
    [
     "ac",
     9,
     0.5
    ],
    [
     "okuboWestFlue",
     13,
     0.6
    ]
   ]
  },
  {
   "id": "oa-n3",
   "x": 165,
   "y": 0,
   "w": 17,
   "h": 4,
   "face": 2,
   "kind": "okuboWestCosmetics",
   "roof": "concrete",
   "sign": {
    "text": "미용",
    "color": "pink"
   },
   "props": [
    [
     "ac",
     1,
     0.5
    ],
    [
     "dish",
     7,
     0.6
    ],
    [
     "okuboWestBoard",
     10,
     0.3
    ]
   ]
  },
  {
   "id": "oa-n4",
   "x": 182,
   "y": 0,
   "w": 18,
   "h": 4,
   "face": 2,
   "kind": "hotel",
   "roof": "tar",
   "sign": {
    "text": "ホテル",
    "color": "pink"
   },
   "props": [
    [
     "tank",
     2,
     0.4
    ],
    [
     "ac",
     8,
     0.6
    ],
    [
     "ac",
     9.5,
     0.6
    ],
    [
     "vent",
     15,
     1
    ]
   ]
  },
  {
   "id": "oa-w1",
   "x": 130,
   "y": 12,
   "w": 14,
   "h": 7,
   "face": 3,
   "kind": "okuboWestBbq",
   "roof": "concrete",
   "sign": {
    "text": "고기",
    "color": "amber"
   },
   "props": [
    [
     "okuboWestFlue",
     2,
     1
    ],
    [
     "ac",
     8,
     0.8
    ],
    [
     "okuboWestBoard",
     5.5,
     2.4
    ],
    [
     "vent",
     12,
     3
    ]
   ]
  },
  {
   "id": "oa-w2",
   "x": 144,
   "y": 12,
   "w": 14,
   "h": 7,
   "face": 3,
   "kind": "okuboWestCosmetics",
   "roof": "ribbed",
   "sign": {
    "text": "コスメ",
    "color": "cyan"
   },
   "props": [
    [
     "ac",
     1.5,
     1
    ],
    [
     "ac",
     3,
     1
    ],
    [
     "hut",
     9,
     1
    ],
    [
     "duct",
     1.5,
     2.8,
     8,
     2.8
    ]
   ]
  },
  {
   "id": "oa-w3",
   "x": 130,
   "y": 21,
   "w": 14,
   "h": 7,
   "face": 2,
   "kind": "okuboWestMart",
   "roof": "tar",
   "sign": {
    "text": "마트",
    "color": "cyan"
   },
   "props": [
    [
     "ac",
     1,
     1
    ],
    [
     "tank",
     6,
     0.8
    ],
    [
     "okuboWestBoard",
     8,
     3
    ],
    [
     "vent",
     3.4,
     3.4
    ]
   ]
  },
  {
   "id": "oa-w4",
   "x": 144,
   "y": 21,
   "w": 14,
   "h": 7,
   "face": 2,
   "kind": "hotel",
   "roof": "concrete",
   "sign": {
    "text": "ホテル",
    "color": "pink"
   },
   "props": [
    [
     "hut",
     1.5,
     1.2
    ],
    [
     "ac",
     8,
     1
    ],
    [
     "ac",
     9.5,
     1
    ],
    [
     "dish",
     11,
     3
    ]
   ]
  },
  {
   "id": "oa-e1",
   "x": 166,
   "y": 12,
   "w": 15,
   "h": 8,
   "face": 4,
   "kind": "okuboWestBbq",
   "roof": "tar",
   "sign": {
    "text": "치킨",
    "color": "cyan"
   },
   "props": [
    [
     "okuboWestFlue",
     2,
     0.8
    ],
    [
     "okuboWestBoard",
     6,
     1.4
    ],
    [
     "ac",
     11,
     0.8
    ],
    [
     "vent",
     13.4,
     2.4
    ]
   ]
  },
  {
   "id": "oa-e2",
   "x": 166,
   "y": 20,
   "w": 5,
   "h": 8,
   "face": 3,
   "kind": "okuboWestGai",
   "roof": "tile",
   "sign": {
    "text": "酒",
    "color": "amber"
   },
   "props": [
    [
     "vent",
     0.5,
     0.6
    ],
    [
     "ac",
     2.6,
     0.8
    ],
    [
     "okuboWestLaundry",
     0.6,
     2.4
    ],
    [
     "vent",
     3.8,
     3.8
    ]
   ]
  },
  {
   "id": "oa-e3",
   "x": 171,
   "y": 20,
   "w": 5,
   "h": 8,
   "face": 3,
   "kind": "okuboWestGai",
   "roof": "tile",
   "props": [
    [
     "vent",
     1.3,
     0.6
    ],
    [
     "ac",
     2.6,
     0.8
    ],
    [
     "okuboWestLaundry",
     0.6,
     2.4
    ],
    [
     "vent",
     3.8,
     3.8
    ]
   ]
  },
  {
   "id": "oa-e4",
   "x": 176,
   "y": 20,
   "w": 5,
   "h": 8,
   "face": 3,
   "kind": "okuboWestGai",
   "roof": "tile",
   "props": [
    [
     "vent",
     0.9,
     0.6
    ],
    [
     "ac",
     2.6,
     0.8
    ],
    [
     "okuboWestLaundry",
     0.6,
     2.4
    ],
    [
     "vent",
     3.8,
     3.8
    ]
   ]
  },
  {
   "id": "oa-e5",
   "x": 183,
   "y": 12,
   "w": 15,
   "h": 8,
   "face": 4,
   "kind": "okuboWestMart",
   "roof": "concrete",
   "sign": {
    "text": "마트",
    "color": "amber"
   },
   "props": [
    [
     "ac",
     1,
     0.8
    ],
    [
     "ac",
     2.4,
     0.8
    ],
    [
     "tank",
     9,
     0.6
    ],
    [
     "okuboWestBoard",
     5,
     1.6
    ],
    [
     "vent",
     13,
     2.6
    ]
   ]
  },
  {
   "id": "oa-e6",
   "x": 183,
   "y": 20,
   "w": 5,
   "h": 8,
   "face": 3,
   "kind": "okuboWestGai",
   "roof": "tile",
   "props": [
    [
     "vent",
     1.3,
     0.6
    ],
    [
     "ac",
     2.6,
     0.8
    ],
    [
     "okuboWestLaundry",
     0.6,
     2.4
    ],
    [
     "vent",
     3.8,
     3.8
    ]
   ]
  },
  {
   "id": "oa-e7",
   "x": 188,
   "y": 20,
   "w": 5,
   "h": 8,
   "face": 3,
   "kind": "okuboWestGai",
   "roof": "tile",
   "props": [
    [
     "vent",
     0.9,
     0.6
    ],
    [
     "ac",
     2.6,
     0.8
    ],
    [
     "okuboWestLaundry",
     0.6,
     2.4
    ],
    [
     "vent",
     3.8,
     3.8
    ]
   ]
  },
  {
   "id": "oa-e8",
   "x": 193,
   "y": 20,
   "w": 5,
   "h": 8,
   "face": 3,
   "kind": "okuboWestGai",
   "roof": "tile",
   "props": [
    [
     "vent",
     0.5,
     0.6
    ],
    [
     "ac",
     2.6,
     0.8
    ],
    [
     "okuboWestLaundry",
     0.6,
     2.4
    ],
    [
     "vent",
     3.8,
     3.8
    ]
   ]
  },
  {
   "id": "oa-d1",
   "x": 130,
   "y": 36,
   "w": 11,
   "h": 10,
   "face": 3,
   "kind": "office",
   "roof": "ribbed",
   "props": [
    [
     "ac",
     1,
     1
    ],
    [
     "ac",
     2.5,
     1
    ],
    [
     "tank",
     6,
     1
    ],
    [
     "hut",
     1.4,
     3.4
    ],
    [
     "vent",
     8,
     5
    ],
    [
     "dish",
     5,
     5.2
    ]
   ]
  },
  {
   "id": "oa-d2",
   "x": 130,
   "y": 46,
   "w": 11,
   "h": 8,
   "face": 3,
   "kind": "okuboWestBbq",
   "roof": "tar",
   "sign": {
    "text": "고기",
    "color": "pink"
   },
   "props": [
    [
     "okuboWestFlue",
     1.5,
     1
    ],
    [
     "ac",
     6,
     1
    ],
    [
     "okuboWestBoard",
     5,
     3
    ],
    [
     "vent",
     9,
     3.4
    ]
   ]
  },
  {
   "id": "shrine",
   "x": 141,
   "y": 36,
   "w": 12,
   "h": 10,
   "face": 4,
   "kind": "okuboWestShrine",
   "roof": "tile",
   "props": []
  },
  {
   "id": "oa-d4",
   "x": 153,
   "y": 36,
   "w": 5,
   "h": 10,
   "face": 3,
   "kind": "okuboWestGai",
   "roof": "tile",
   "sign": {
    "text": "スナック",
    "color": "cyan"
   },
   "props": [
    [
     "vent",
     1.2,
     1.4
    ],
    [
     "ac",
     3,
     3
    ]
   ]
  },
  {
   "id": "oa-d5",
   "x": 153,
   "y": 46,
   "w": 5,
   "h": 8,
   "face": 3,
   "kind": "okuboWestGai",
   "roof": "tile",
   "sign": {
    "text": "夜",
    "color": "pink"
   },
   "props": [
    [
     "vent",
     3,
     1.2
    ]
   ]
  },
  {
   "id": "oa-f1",
   "x": 166,
   "y": 36,
   "w": 16,
   "h": 4,
   "face": 2,
   "kind": "karaoke",
   "roof": "tar",
   "sign": {
    "text": "カラオケ",
    "color": "amber"
   },
   "props": [
    [
     "ac",
     1,
     0.5
    ],
    [
     "ac",
     2.4,
     0.5
    ],
    [
     "okuboWestBoard",
     7,
     0.3
    ],
    [
     "vent",
     14,
     1
    ]
   ]
  },
  {
   "id": "oa-f2",
   "x": 182,
   "y": 36,
   "w": 16,
   "h": 4,
   "face": 2,
   "kind": "pachinko",
   "roof": "concrete",
   "sign": {
    "text": "パチンコ",
    "color": "cyan"
   },
   "props": [
    [
     "tank",
     1,
     0.4
    ],
    [
     "ac",
     8,
     0.6
    ],
    [
     "ac",
     9.4,
     0.6
    ],
    [
     "dish",
     13,
     0.6
    ]
   ]
  },
  {
   "id": "oa-f3",
   "x": 166,
   "y": 42,
   "w": 15,
   "h": 4,
   "face": 2,
   "kind": "okuboWestBbq",
   "roof": "tar",
   "sign": {
    "text": "고기",
    "color": "amber"
   },
   "props": [
    [
     "okuboWestFlue",
     2,
     0.5
    ],
    [
     "ac",
     8,
     0.6
    ],
    [
     "vent",
     12,
     0.8
    ]
   ]
  },
  {
   "id": "oa-f4",
   "x": 182,
   "y": 42,
   "w": 16,
   "h": 4,
   "face": 2,
   "kind": "okuboWestCosmetics",
   "roof": "ribbed",
   "sign": {
    "text": "コスメ",
    "color": "pink"
   },
   "props": [
    [
     "ac",
     1,
     0.6
    ],
    [
     "okuboWestBoard",
     6,
     0.3
    ],
    [
     "dish",
     13,
     0.6
    ]
   ]
  },
  {
   "id": "oa-g1",
   "x": 166,
   "y": 48,
   "w": 9,
   "h": 6,
   "face": 3,
   "kind": "okuboWestMart",
   "roof": "concrete",
   "sign": {
    "text": "마트",
    "color": "pink"
   },
   "props": [
    [
     "ac",
     1,
     0.8
    ],
    [
     "ac",
     2.4,
     0.8
    ],
    [
     "hut",
     5,
     0.5
    ],
    [
     "vent",
     7.5,
     2
    ]
   ]
  },
  {
   "id": "oa-g2",
   "x": 176,
   "y": 48,
   "w": 5,
   "h": 6,
   "face": 3,
   "kind": "okuboWestGai",
   "roof": "tile",
   "sign": {
    "text": "酒",
    "color": "cyan"
   },
   "props": [
    [
     "vent",
     1.3,
     0.6
    ],
    [
     "ac",
     2.6,
     0.8
    ]
   ]
  },
  {
   "id": "oa-g3",
   "x": 181,
   "y": 48,
   "w": 5,
   "h": 6,
   "face": 3,
   "kind": "okuboWestGai",
   "roof": "tile",
   "props": [
    [
     "vent",
     0.9,
     0.6
    ],
    [
     "ac",
     2.6,
     0.8
    ]
   ]
  },
  {
   "id": "oa-g4",
   "x": 186,
   "y": 48,
   "w": 6,
   "h": 6,
   "face": 3,
   "kind": "okuboWestGai",
   "roof": "tile",
   "sign": {
    "text": "バー",
    "color": "pink"
   },
   "props": [
    [
     "vent",
     0.5,
     0.6
    ],
    [
     "ac",
     3.6,
     0.8
    ]
   ]
  },
  {
   "id": "oa-g5",
   "x": 192,
   "y": 48,
   "w": 6,
   "h": 6,
   "face": 3,
   "kind": "okuboWestGai",
   "roof": "tile",
   "props": [
    [
     "vent",
     0.5,
     0.6
    ],
    [
     "ac",
     3.6,
     0.8
    ]
   ]
  }
 ],
 "lamps": [
  [134, 5.6, "s"],
  [150, 5.6, "s"],
  [168, 5.6, "s"],
  [186, 5.6, "s"],
  [194, 5.6, "s"],
  [134, 10.5, "n"],
  [150, 10.5, "n"],
  [168, 10.5, "n"],
  [186, 10.5, "n"],
  [194, 10.5, "n"],
  [134, 29.6, "s"],
  [150, 29.6, "s"],
  [168, 29.6, "s"],
  [186, 29.6, "s"],
  [194, 29.6, "s"],
  [134, 34.5, "n"],
  [150, 34.5, "n"],
  [168, 34.5, "n"],
  [186, 34.5, "n"],
  [194, 34.5, "n"],
  [134, 55.6, "s"],
  [156, 55.6, "s"],
  [168, 55.6, "s"],
  [186, 55.6, "s"],
  [194, 55.6, "s"],
  [159.6, 14, "e"],
  [164.4, 14, "w"],
  [159.6, 24, "e"],
  [164.4, 24, "w"],
  [159.6, 38, "e"],
  [164.4, 38, "w"],
  [159.6, 44, "e"],
  [164.4, 44, "w"],
  [159.6, 50, "e"],
  [164.4, 50, "w"]
 ]
}
